/**
 * Check if the code is being run in jest.
 */ export var isTestEnv = function() {
    return "production" === "test";
};
